import { getShowConfirmationPage } from '../../../selectors/tools';
import { useSelector } from 'react-redux';
import DTChangeOrderAddressNode from '../NodeGroups/DTSelectedItemTransaction/Nodes/DTChangeOrderAddress/DTChangeOrderAddressNode';

const ChangeOrderAddressThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTChangeOrderAddressNode showConfirmation={showConfirmationPage} message={'The order address has been changed.'} />
  );
};

export default ChangeOrderAddressThenSendMacro;
